import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SupportInfoService {
	// State of the support info dropdown
	private dropdownSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	public get dropdownOpened$(): Observable<boolean> {
		return this.dropdownSubject.asObservable();
	}

	constructor() {}

	public supportInfoDropdownOpen(b: boolean) {
		this.dropdownSubject.next(b);
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
